var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var graphQlTokens = require('./tokens').graphQlTokens;
import { BaseGraphQlParser } from './BaseGraphQlParser';
import { Parser } from 'chevrotain';
var StandardGraphQlParser = /** @class */ (function (_super) {
    __extends(StandardGraphQlParser, _super);
    function StandardGraphQlParser(options) {
        var _this = _super.call(this, options, graphQlTokens) || this;
        Parser.performSelfAnalysis(_this);
        return _this;
    }
    return StandardGraphQlParser;
}(BaseGraphQlParser));
export { StandardGraphQlParser };
